<template>
	<inertia-head title="INVESTMENT CALCULATOR" />
	<div class="py-3">
		<div>
			<div class="text-center fs-4 fw-semibold mb-5">
				<h1 class="mb-5 border-bottom">INVESTMENT CALCULATOR</h1>
				<h2>Compute What Happens</h2>
				<h2>If You Invest In...</h2>
			</div>
			<div class="mb-5">
				<p>Here's a simple Calculator to find out how much you'll have if you invest each month in various "investment vehicles".</p>
				<p>* Stock Market is a long-term investment.  Unlike the other three vehicles where interests are guaranteed every year, this growth rate in the Stock Market is made only if you keep investing for many years.  For more information about how to invest in the Stock Market, <a>click here</a>.</p>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12 m-auto">
				<div class="block block-rounded shadow">
					<div class="block-content bg-primary-light">
						<h3 class="text-center">Your Investment Plan</h3>
					</div>
					<div role="tablist" class="my-5 border-bottom border-warning">
						<button type="button" @click="planOption('monthly_investment')" id="tab_monthly" class="btn btn-outline-warning rounded-0 ms-2 px-4 active mt-2 border-0" role="tab" data-bs-toggle="tab" data-bs-target="#btabs-animated-fade-monthly-investment" aria-controls="btabs-animated-fade-monthly-investment" aria-selected="true">Monthly Investment</button>
						<button type="button" @click="planOption('target_amount')" id="tab_target_amount" class="btn btn-outline-warning rounded-0 ms-2 px-4 mt-2 border-0" role="tab" data-bs-toggle="tab" data-bs-target="#btabs-animated-fade-target-amount" aria-controls="btabs-animated-fade-target-amount">Target Amount Investment</button>
					</div>
					<div class="block-content pb-5">
						<div v-if="data.plan_option=='monthly_investment'" class="row mb-5">
							<div class="col-lg-5">
								<h4 class="m-1">Initial Investment</h4>
								<p class="text-muted m-1">How much money you want to start investing with</p>
								<div class="form-group input-group">
									<span class="input-group-text">₱</span>
									<input type="number" v-model="data.initial_amount" name="" class="form-control" title="Inital Investment" min="1000" />
								</div>
							</div>
							<div class="col-lg-2 my-3"></div>
							<div class="col-lg-5">
								<h4 class="m-1">Monthly Contribution</h4>
								<p class="text-muted m-1">Amount that you want to add to your investment every month</p>
								<div class="form-group input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">₱</span>
									</div>
									<input type="number" v-model="data.monthly_amount" name="" class="form-control" title="Monthly Contribution" min="500" />
								</div>
							</div>
						</div>
						<div v-else class="row mb-5">
							<div class="col-lg-12">
								<h4 class="m-1">Target Amount</h4>
								<p class="text-muted m-1">How much money you want to target in the future</p>
								<div class="form-group input-group">
									<span class="input-group-text">₱</span>
									<input type="number" v-model="data.future_amount" name="" class="form-control" title="Future Amount" min="500000" />
								</div>
							</div>
							<!-- <div class="col-lg-2 my-3"></div>
							<div class="col-lg-5">
								<h4 class="m-1">Monthly Contribution</h4>
								<p class="text-muted m-1">Amount that you need to investment every month based on you target amount</p>
								<div class="form-group input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">₱</span>
									</div>
									<div class="form-control">{{data.monthly_amount}}</div>
								</div>
							</div> -->
						</div>
						<div class="row">
							<div class="col-lg-5">
								<h4 class="m-1">Years to Grow</h4>
								<p class="text-muted m-1">Number of years you intend to stay invested</p>
								<div class="form-group">
									
								</div>
								<div class="form-group input-group">
									<input type="number" v-model="data.year_grow" name="" class="form-control" title="Years to Grow" min="1" />
									<div class="input-group-prepend">
										<span class="input-group-text">YEAR<span v-if="data.year_grow>1">S</span></span>
									</div>
								</div>
							</div>
							<div class="col-lg-2 my-3"></div>
							<div class="col-lg-5">
								<h4 class="m-1">Rate of Return</h4>
								<p class="text-muted m-1">The average annual on your investment is</p>
								<div class="form-group">
									
								</div>
								<div class="form-group input-group">
									<input type="number" v-model="data.rate_return" name="" class="form-control" title="Rate of Return" min="1" />
									<div class="input-group-prepend">
										<span class="input-group-text">%</span>
									</div>
								</div>
							</div>
						</div>
						<div class="row mt-5">
							<div class="col-lg-12">
								<div class="text-center">
									<button @click="calculate" class="btn btn-primary btn-lg">CALCULATE</button>
								</div>
							</div>
						</div>
						<div v-if="data.future_amount>0" class="row mt-5">
							<h3 class="text-center text-danger">FUTURE ENDING BALANCE: {{moneyFormat(data.future_amount)}}</h3>
							<div class="col-lg-12">
								<vue-chart ref="dataList"/>
							</div>

							<div class="col-lg-12 table-responsive mt-5">
								<table class="table">
									<thead>
										<tr class="text-center">
											<th>Year</th>
											<th>Beginning Balance</th>
											<th>Monthly Contribution</th>
											<th>Total Annual Contributions</th>
											<th>Withdraw</th>
											<th>Interest Earned</th>
											<th>Total Interest Earned</th>
											<th>Ending Balance</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(entry,eindex) in data.calculate_data">
											<td>{{entry.year}}</td>
											<td>{{moneyFormat(entry.begin_balance)}}</td>
											<td>
												<!-- <div v-if="!entry.enable_modify">{{moneyFormat(entry.annual_amount)}}</div> -->
												<div v-if="data.plan_option=='target_amount'">{{moneyFormat(entry.monthly_amount)}}</div>
												<div v-else>
													<input type="number" @blur="generateData('update')" v-model="entry.monthly_amount" name="" min="500" class="form-control">
												</div>
											</td>
											<td>{{moneyFormat(entry.total_annual)}}</td>
											<td>
												<!-- <div v-if="!entry.enable_modify">{{moneyFormat(entry.withdraw)}}</div> -->
												<div v-if="data.plan_option=='target_amount'">{{moneyFormat(entry.withdraw)}}</div>
												<div v-else>
													<input type="number" @blur="generateData('update')" v-model="entry.withdraw" name="" min="500" class="form-control">
												</div>
											</td>
											<td>{{moneyFormat(entry.earn)}}</td>
											<td>{{moneyFormat(entry.total_earn)}}</td>
											<td>{{moneyFormat(entry.end_balance)}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			
		<!-- Footer -->
		<footer id="page-footer">
			<div class="content py-3">
				<div class="row fs-sm">
					<div class="col-sm-12 order-sm-1 py-1 text-center">
						<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
						&copy; {{ $page.props.app.year }}
					</div>
				</div>
			</div>
		</footer>

	</div>
	
</template>
<script>

import {ref, reactive, watch} from "vue";	
import GuestLayout from '../Layouts/GuestLayout';
import VueChart from '../Shared/Components/VueChart';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	props: {},
	components:{ VueChart },
	mounted(){ this.data.page = this.$page; },
	setup(props){
		
		const data = reactive({
			initial_amount 	: 10000,
			monthly_amount 	: 2000,
			annual_amount 	: 0,
			year_grow		: 5,
			rate_return 	: 10,
			percent_rate 	: 0,
			future_amount 	: 0,
			plan_option 	: 'monthly_investment',
			calculate_data 	: [],
			page 			: []
		});

		const dataList = ref();

		const planOption = (_plan_option)=>{
			data.plan_option = _plan_option;
			data.future_amount = 0;
			if(data.plan_option=='monthly_investment')
			{
				data.monthly_amount = 2000;
			}else
			{
				data.monthly_amount = 0;
			}
		}


		const calculate = () => {

			data.percent_rate 	= 1 + (parseFloat(data.rate_return)/100);

			if(data.plan_option=='monthly_investment')
			{
				data.annual_amount 	= parseFloat(data.monthly_amount)*12;
				
				generateData('calculate');
			}else
			{
				generateDataTargetAmount('calculate');
			}
		}

		const futureAmount = (_begin_bal,_year) => {
			var future_amount = parseFloat(_begin_bal) * Math.pow(data.percent_rate,parseInt(_year));
			return future_amount;
		}

		const geomSeries = (_annual,_year) => {
			var geom 		= _annual * ((Math.pow(data.percent_rate,parseInt(_year)+1)-1)/(data.percent_rate-1));
			var geom_m 		= _annual * ((Math.pow(data.percent_rate,parseInt(_year))-1)/(data.percent_rate-1));
			var geom_final 	= geom - geom_m;
			
			return geom_final;
		}

		const endBalancePerYear = (_end_bal,_annual) => {
			var future_amount 	= futureAmount(_end_bal,1);
			var geom_final 		= geomSeries(_annual,1);

			var balance 		= future_amount + geom_final;

			return balance;
		}

		const getMonthlyContribution = (_rate,_term,_amount)=>{
			var monthly_amount = 0;
			var term =  _term
			var rate =  (_rate/100);
			var pv 	 = 0;
			var fv 	 = -1;
			var type = 1;
			
			var formula = Math.pow(1+rate,term);
			
			monthly_amount = (-(rate * (fv + (formula * pv))) / ((-1 + formula) * (1 + rate * (type))))/12;
			
			monthly_amount = _amount * monthly_amount;
		
			// monthly_amount = geom/(Math.pow(1+(_rate/100),parseInt(term))-1);
			
			return monthly_amount;
		}

		const generateData = (_action)=>{
			var cur_date 	= new Date();
			var cur_year 	= cur_date.getFullYear();
			var year 		= cur_year;
			var data_length = 0;
			var old_data 	= [];
			var new_data 	= [];
			var begin_balance=0,less_withdraw=0,monthly_amount=0,annual_amount=0,earn=0,prev_earn=0,total_earn=0,end_balance=0;

			if(_action=='calculate'){
				data_length = data.year_grow;
			}else{
				data_length = data.calculate_data.length;
				old_data 	= data.calculate_data;
			}

			for (var i = 0; i < data_length; i++) {
				var entry 		= [];
				var withdraw 	= 0;

				if(_action=='calculate'){
					year 			= cur_year+i;
					begin_balance 	= (i==0) ? data.initial_amount : parseFloat(new_data[i-1].end_balance);
					monthly_amount 	= data.monthly_amount;
					annual_amount 	= data.annual_amount;
				}else{

					entry 			= old_data[i];

					year 			= entry.year;
					withdraw 		= entry.withdraw=='' ? 0 : entry.withdraw;
					begin_balance 	= (i==0) ? entry.begin_balance : parseFloat(new_data[i-1].end_balance);
					monthly_amount 	= entry.monthly_amount=='' ? 0 : parseFloat(entry.monthly_amount);
					// annual_amount 	= entry.annual_amount=='' ? 0 : parseFloat(entry.annual_amount);
					annual_amount 	= parseFloat(monthly_amount)*12;
				}

				if(withdraw==''){
					withdraw = 0;
				}

				less_withdraw 	= begin_balance - parseFloat(withdraw);
				end_balance 	= endBalancePerYear(less_withdraw,annual_amount);
				earn 			= end_balance - (less_withdraw + annual_amount);
				prev_earn 		= (i==0) ? 0 : parseFloat(new_data[i-1].total_earn);
				total_earn 		= earn + prev_earn;

				new_data.push({
					year 			: year,
					begin_balance 	: less_withdraw.toFixed(2),
					monthly_amount 	: monthly_amount,
					annual_amount 	: annual_amount,
					total_annual 	: (annual_amount + (i==0 ?0:parseFloat(new_data[i-1].total_annual))).toFixed(2),
					withdraw 		: withdraw,
					earn 			: earn.toFixed(2),
					total_earn 		: total_earn.toFixed(2),
					end_balance 	: end_balance.toFixed(2),
					enable_modify	: data.page.props.user ? true : false
				});

			}

			data.future_amount  = new_data[new_data.length-1].end_balance;

			data.calculate_data = new_data;

		}

		const generateDataTargetAmount = (_action)=>{
			var cur_date 	= new Date();
			var cur_year 	= cur_date.getFullYear();
			var year 		= cur_year;
			var data_length = 0;
			var old_data 	= [];
			var new_data 	= [];
			var begin_balance=0,less_withdraw=0,monthly_amount=0,annual_amount=0,earn=0,prev_earn=0,total_earn=0,end_balance=0;

			if(_action=='calculate'){
				data_length = data.year_grow;
			}else{
				data_length = data.calculate_data.length;
				old_data 	= data.calculate_data;
			}

			for (var i = 0; i < data_length; i++) {
				var entry 		= [];
				var withdraw 	= 0;

				if(_action=='calculate'){
					year 			= cur_year+i;
					monthly_amount 	= getMonthlyContribution(data.rate_return,data.year_grow,data.future_amount);
					data.monthly_amount = monthly_amount;
					annual_amount 	= monthly_amount*12;
					begin_balance 	= (i==0) ? 0 : parseFloat(new_data[i-1].end_balance);
				}else{

					entry 			= old_data[i];

					year 			= entry.year;
					withdraw 		= entry.withdraw=='' ? 0 : entry.withdraw;
					begin_balance 	= (i==0) ? entry.begin_balance : parseFloat(new_data[i-1].end_balance);
					monthly_amount 	= entry.monthly_amount=='' ? 0 : parseFloat(entry.monthly_amount);
					// annual_amount 	= entry.annual_amount=='' ? 0 : parseFloat(entry.annual_amount);
					annual_amount 	= parseFloat(monthly_amount)*12;
				}

				if(withdraw==''){
					withdraw = 0;
				}

				less_withdraw 	= begin_balance - parseFloat(withdraw);
				end_balance 	= endBalancePerYear(less_withdraw,annual_amount);
				earn 			= end_balance - (less_withdraw + annual_amount);
				prev_earn 		= (i==0) ? 0 : parseFloat(new_data[i-1].total_earn);
				total_earn 		= earn + prev_earn;

				new_data.push({
					year 			: year,
					begin_balance 	: less_withdraw.toFixed(2),
					monthly_amount 	: monthly_amount,
					annual_amount 	: annual_amount,
					total_annual 	: (annual_amount + (i==0 ?0:parseFloat(new_data[i-1].total_annual))).toFixed(2),
					withdraw 		: withdraw,
					earn 			: earn.toFixed(2),
					total_earn 		: total_earn.toFixed(2),
					end_balance 	: end_balance.toFixed(2),
					enable_modify	: data.page.props.user ? true : false
				});

			}

			data.monthly_amount  = monthly_amount.toFixed(2);

			data.calculate_data = new_data;

		}

		watch(()=>data.calculate_data,(new_data,old_data)=>{
			dataList.value?.getData(new_data);
		});

		const moneyFormat = (amount)=>{
			return new Intl.NumberFormat("en-US", {
					  style: "currency",
					  currency: "PHP"
					}).format(amount);
		}

		return{
			planOption,
			data,
			dataList,
			calculate,
			futureAmount,
			geomSeries,
			endBalancePerYear,
			generateData,
			generateDataTargetAmount,
			moneyFormat
		}

	}
}
</script>
